import { QuizPlayer } from "./QuizPlayer";

export function isPlayerWithEmail(quizPlayer: QuizPlayer): boolean {
    return (
        (quizPlayer.userEmail !== "" || quizPlayer.invitationMail !== "") &&
        !quizPlayer.guestName
    );
}